<template>
    <form class="search-container">
        <input class="searchbar" type="text" name="searchBlogs" :value="searchString" @input="handleInput" placeholder="Išči po blogu..." >
        <input type="submit" value="" @click="changePropFilter">
        <a href="#blog" :class="`scroll-link navigation-item close ${searchString ? '' : 'hidden'}`" @click="handleClose"></a>
    </form>
</template>


<script>
    export default {
        props: ["searchString", "handleSearch"],
        mounted() {
            this.filter = "";
        },
        methods: {
            handleInput(e) {
                this.filter = e.target.value;
            },
            handleClose() {
                this.filter = "";
                this.handleSearch("");
            },
            changePropFilter(e) {
                e.preventDefault();
                this.handleSearch(this.filter);
            }
        }
    }
</script>
